//引入api接口
import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      bidWinner:true, // 收起 展开 中标人信息
      detail: {
        /********************* 招标概况 *********************/
        guid: null, // 主键
        method: null, // 处理方式
        title: null, // 标题
        bianhao: null, // 工程编号
        xmlb: null, // 项目类型
        gclb: null, // 工程类别
        gcBh: null, // 招标项目编号
        gcName: null, // 招标项目名称
        bdName: null, // 标段名称
        xmBh: null, // 项目编号
        xmName: null, // 项目名称
        zbgsStartTime: null, // 公示时间
        zbrAndLht: null, // 招标人
        jingBanRenName: null, // 经办人
        jingBanRenPhone: null, // 办公电话
        zbrAddress: null, // 联系地址
        zbdlJg: null, // 招标代理机构
        zbDlJinBanRenName: null, // 经办人
        zbDlJinBanRenPhone: null, // 办公电话
        zbdlAddress: null, // 联系地址
        zbFangShi: null, // 招标方式
        /********************* 中标人信息 *********************/
        tbrName: null, // 中标人
        qfxs: null, // 中标价取费形式
        zhongBiaoFl: null, // 中标价（费率）
        zhongBiaoJe: null, // 中标价
        zhongBiaoGq: null, // 中标工期
        zhiLiangBz: null, // 质量标准
        xiangMuJiLi: null, // 项目经理
        ziGeDengJi: null, // 资格等级
        ziGeZhengShu: null // 资格证书
      },
      detailsList: [
        {
          title: "中标（定标）结果公告",
          show: true,
          result: [
            {
              name: "招标项目编号",
              value: "42070720220628001001"
            },
            {
              name: "招标项目名称",
              value: "42070720220628001001"
            },
            {
              name: "标段名称",
              value: "42070720220628001001"
            },
            {
              name: "项目编号",
              value: "42070720220628001001"
            },
            {
              name: "项目名称",
              value: "42070720220628001001"
            },
            {
              name: "公示时间",
              value: "42070720220628001001"
            },
            {
              name: "招标人",
              value: "42070720220628001001"
            },
            {
              name: "经办人",
              value: "42070720220628001001"
            },
            {
              name: "办公电话",
              value: "42070720220628001001"
            },
            {
              name: "联系地址",
              value: "42070720220628001001"
            },
            {
              name: "招标代理机构",
              value: "42070720220628001001"
            },
            {
              name: "经办人",
              value: "42070720220628001001"
            },
            {
              name: "办公电话",
              value: "42070720220628001001"
            },
            {
              name: "联系地址",
              value: "武汉市江夏区文化大道399号联投大厦20层"
            },
            {
              name: "招标方式",
              value: "公开招标"
            }
          ]
        },
        {
          title: "中标人信息",
          show: true,
          result: [
            {
              name: "中标人",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "中标价取费形式",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "中标价",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "中标工期",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "质量标准",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "项目经理",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "资格等级",
              value: "湖北省建筑设计院有限公司//湖北省路桥集团天夏建设有限公司"
            },
            {
              name: "资格证书",
              value: ""
            }
          ]
        }
      ]
    };
  },
  mounted() {
    // 获取主键
    this.guid = this.$route.query.guid;
    // 获取公告详情
    this.fun_GetDetail();
  },
  // 自定义事件
  methods: {
    /***********************************公告信息**************************************/
    /**
     * 获取公告信息
     */
    fun_GetDetail() {
      // 请求
      fun_PostAction("/hiConstruction/publicityBidWinningAwardResultsDetail", {
        guid: this.guid // 主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          this.detail = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    }
  }
};
